export enum Locale {
  EN_US = 'en-US',
  SR_LATN = 'sr-Latn',
}

export const DEFAULT_LOCALE = Locale.EN_US;

// The languages CONTENT can be translated into (the *Translations tables:
// exercises, workouts, programs, nutrition, education, categories…, the
// public-page headline, the "about" text). Wider than `Locale`, which is the
// language of the UI, e-mails and documents and stays en-US / sr-Latn. The
// extra languages are the ones V1 content carries; bare language subtags
// because V1 never recorded a region.
export const CONTENT_LOCALES = [
  Locale.EN_US,
  Locale.SR_LATN,
  'hr',
  'de',
  'es',
  'ro',
  'ru',
  'bg',
  'pl',
] as const;
export type ContentLocale = (typeof CONTENT_LOCALES)[number];
